import React from "react";
import { PAGE_TITLE } from "@/common/constants/constants";
import aboutCompanyDataFetch from "@/data/domain/about-company.json";
import { v4 as uuidv4 } from "uuid";

import styles from "./AboutCompanyDescription.module.scss";

const AboutCompanyDescription = () => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{PAGE_TITLE.ABOUT_US_TITLE}</h1>
      <div className={styles.description}>
        {aboutCompanyDataFetch?.description.map((item) => {
          return <div key={uuidv4()}>{item.paragraph}</div>;
        })}
      </div>
    </div>
  );
};

export default AboutCompanyDescription;
